<template>
  <!-- 正文 -->
  <div class="liu" v-wechat-title="'银行卡认证'">
    <!-- 银行卡信息 -->
    <div class="color-f-bg margin-t-15">
      <!-- 卡类型 -->
      <div class="margin-l-15">
        <div class="flex-s form-item">
          <div style="width: 95px;">卡类型</div>
          <input type="tel" class="flex-1" v-model.trim="formData.bankName" disabled />
        </div>
        <div class="line" />
      </div>
      <div class="flex-s margin-l-15 form-item">
        <div style="width: 95px;">卡号</div>
        <input type="tel" class="flex-1" v-model.trim="bankCardNo" disabled />
      </div>
    </div>
    <!-- 人脸提示文字 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      <span>请验证持卡人本人人脸信息</span>
    </div>
    <!-- 人脸识别 -->
    <div class="flex-s page-padding-l-r padding-t-10 padding-b-10 color-f-bg">
      <div class="flex-s">
        <div style="width: 95px;">人脸识别</div>
        <div class="faceStyle" @click="onCameraImgClick('renLian')">
          <img v-if="renLian.webUrl" class="img" :src="renLian.webUrl" />
          <svg-icon v-else class-name="img" icon-class="camera_face" />
        </div>
      </div>
      <div class="btn-box">
        <div v-if="noHasHxtFaceImg" class="btn" @click="onHxtGetFaceBtnClick">
          获取人脸照片
        </div>
      </div>
    </div>
    <!-- 人脸识别 对比失败 提示 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6" v-show="isFail">
      人脸识别对比失败，请
      <span class="theme-color" @click="resetCameraInfo('renLian'), resetCameraInfo('shouChi')">重新识别</span>或
      <span class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
    </div>
    <!-- 手持提示文字 -->
    <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
      <span>请验证持卡人本人手持身份证信息</span>
    </div>
    <!-- 手持身份证 -->
    <div class="flex-s page-padding-l-r padding-t-10 padding-b-10 color-f-bg">
      <div style="width: 95px;">
        <div>手持身份</div>
        <div>证正面照</div>
      </div>
      <div class="handFaceStyle" @click="onCameraImgClick('shouChi')">
        <img class="img" :src="shouChi.webUrl || require('@/assets/handheld_example@3x.png')" />
      </div>
    </div>
    <!-- 手持身份证 对比失败 提示 -->
    <div>
      <div class="page-padding-l-r padding-t-10 padding-b-10 say-color title-6">
        <span>避免证件与头部重叠，身份证证件内容要清晰可见，完全露出双手手臂</span>
        <span v-show="isFail">，如对比失败，请</span>
        <span v-show="isFail" class="theme-color"
          @click="resetCameraInfo('renLian'), resetCameraInfo('shouChi')">重新拍照</span>
        <span v-show="isFail">或</span>
        <span v-show="isFail" class="theme-color" @click="jumpManualAudit()">申请人工审核</span>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" @click="submitData">提交</mt-button>
    </div>
    <!-- 百度人脸识别弹窗 -->
    <mt-popup class="liveness-popup" v-model="livingFacePopupVisible" :closeOnClickModal="false">
      <liveness ref="liveness"></liveness>
    </mt-popup>
  </div>
</template>

<script>
/* global PUBLIC_TOKEN */
/* global PUBLIC_PRODUCT */
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import Liveness from '@/components/Liveness';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';
import { VerIdCardFace, AuditBankElementsStatus, YMTivingThing } from '@/api/weChat';
import { GetHXTLivenessDetectionUrl, QueryHXTLivenessDetectionResult, InitALiFaceVerify } from '@/api/faceVerify';
import { SucceedHandle, SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'LargeAuth',
  components: { SvgIcon, Liveness },
  data() {
    return {
      // 人脸照片
      renLian: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 云码通人脸识别
      ymt: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 手持照片
      shouChi: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 表单数据
      formData: {
        bankName: '',
        bankCardNo: '',
      },
      // 活体认证类型
      faceDetectActivity: 0,
      // 百度人脸弹窗开关
      livingFacePopupVisible: false,
      // 认识是否失败
      isFail: false,
    };
  },
  watch: {
    livingFaceImgUrl(val) {
      this.renLian.base64 = val;
      this.renLian.fileUrl = val;
      this.renLian.webUrl = val;
    },
    livingFacePopupStatus(val) {
      this.livingFacePopupVisible = val;
    },
  },
  computed: {
    ...mapGetters(['livingFaceImgUrl', 'livingFacePopupStatus']),
    bankCardNo() {
      return this.formData.bankCardNo.substr(0, 6) + '********' + this.formData.bankCardNo.substr(-4); // 卡号
    },
    noHasHxtFaceImg() {
      return this.faceDetectActivity === 5 && this.renLian.webUrl && this.renLian.webUrl.indexOf("jpeg") === -1
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$route.query.fromh5faceflag) {
        // 从H5人脸跳回来，从localStorage取数据
        this.readDataByLocalStorage(this.$route.query.fromh5faceflag);
      } else {
        // 反之，则直接从url中取数据
        this.readDataByRouteQuery();
      }
    });
  },
  methods: {
    ...mapMutations(['setLivingFacePopupStatus']),
    // 2026.7 读取LocalStorage中数据给页面变量赋值
    readDataByLocalStorage(fromFlag) {
      // 获取localStorage中存储的url参数
      const paramStr = localStorage.getItem("h5Face_urlParam");

      // 获取参数值的函数
      const getParamValue = (search, paramName) => {
        const obj = {};
        const arr = search.split('&');
        for (let i = 0, newArr = []; i < arr.length; i++) {
          newArr = arr[i].split('=');
          if (typeof obj[newArr[0]] === 'undefined') { obj[newArr[0]] = newArr[1]; }
        }
        return obj[paramName] || '';
      }

      // 给变量赋值
      this.formData.bankName = getParamValue(paramStr, "bankname");
      this.formData.bankCardNo = getParamValue(paramStr, "bankcardno");
      this.faceDetectActivity = parseInt(getParamValue(paramStr, "facedetectactivity"));

      // 因小程序webview跳转阿里人脸h5成功后再回跳回当前页面后无法调用接口
      // 所以改为给小程序发消息，用小程序调用接口，来查询人脸结果
      let data = null;
      if (fromFlag === 'h') {
        data = this.createPostMessage("hXtH5Face");
        wx.miniProgram.postMessage({ data });
        wx.miniProgram.redirectTo({
          url: '/pages/media/media',
        });
      } else {
        data = this.createPostMessage("aLiH5Face");
        wx.miniProgram.postMessage({ data });
        wx.miniProgram.redirectTo({
          url: '/pages/media/media',
        });
      }
    },
    // 2026.7 读取route.query中数据给页面变量赋值
    readDataByRouteQuery() {
      this.formData.bankName = this.$route.query.bankname;
      this.formData.bankCardNo = this.$route.query.bankcardno;
      this.faceDetectActivity = parseInt(this.$route.query.facedetectactivity);
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.renLian.webUrl = decodeURIComponent(this.$route.query.rlweburl).replace('|', '?');
        this.shouChi.webUrl = decodeURIComponent(this.$route.query.scweburl).replace('|', '?');
        switch (imgType) {
          case 'ymt':
            if (this.renLian.webUrl) {
              this.yMTivingThing();
            }
            break;
          case 'renLian':
          case 'shouChi':
          case 'aLiH5Face':
            break;
          case 'hXtH5Face':
            // // 将传回的h5人脸网络图片转成base64编码，再上传到图片服务器
            // // 获取手机号
            // const mobile = this.$route.query.mobile;
            // // 转换格式
            // this.convertImageToBase64(this.renLian.webUrl, base64Data => {
            //   // CusAlert(base64Data);
            //   // 上传base64到图片服务器
            //   upLoadImg("", base64Data, "renLian", mobile, yes => {
            //     // 成功后取图片服务器上的照片并赋值
            //     this.renLian.webUrl = yes.data;
            //   }, no => {
            //     // 失败提示重新做人脸
            //     this.resetCameraInfo('renLian', 2);
            //   });
            // });
            break;
        }
      }
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this.isFail = false;
    },
    // 提交按钮点击
    submitData() {
      if (!this.renLian.webUrl) {
        CusToast('请先进行人脸识别');
        return;
      }
      if (!this.shouChi.webUrl) {
        CusToast('请上传手持身份证照片');
        return;
      }
      CusLoadingOpen();
      VerIdCardFace({
        cardNum: this.formData.bankCardNo,
        url: this.renLian.webUrl,
        isAddHoldIDCard: 1,
        holdIDCardUrl: this.shouChi.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          const msg = SucceedHandle(res.code, res.msg, () => {
            CusAlert(res.msg, () => {
              wx.miniProgram.switchTab({
                url: `/pages/home/home`,
              });
            });
          });
          if (res.code === 9069) {
            CusAlert(res.msg, () => (this.isFail = true));
          } else {
            msg && CusToast(msg);
          }
        })
        .catch(err => {
          CusLoadingClose();
          if ((err.code === 9990 && err.innerCode === 7775) || err.innerCode === 7776) {
            // 自动人工审核
            let msg = err.msg;
            if (err.innerCode === 7776) {
              msg = '今日人脸对比次数已达上限，已为您申请人工审核，预计将在1个工作日内完成审核';
            }
            CusAlert(msg, () => {
              // 1.向小程序发消息，更新状态
              wx.miniProgram.postMessage({ data: { page: 'refresh' } });
              // 2.跳转小程序银行卡认证页面
              wx.miniProgram.redirectTo({
                url: `/pages/bankcardAuth/authIndex?pageTitle=银行卡认证`,
              });
            });
          } else {
            CusAlert(err.msg, () => (this.isFail = true));
          }
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 跳人工审核
    jumpManualAudit() {
      CusAlert('人工审核将在1个工作日内处理完成，是否确定申请人工审核', () => {
        CusAlert('已为您提交人工审核，请继续完成后续认证流程，否则将无法通过人工审核', () => {
          AuditBankElementsStatus({
            cardNum: this.formData.bankCardNo, // 卡号 ,
            faceUrl: this.renLian.webUrl, // 人像url ,
            holdidcard: this.shouChi.webUrl, // 手持照片url
          })
            .then(res => {
              CusLoadingClose();
              const msg = SucceedHandle(res.code, res.msg, () => {
                CusAlert(res.msg, () => {
                  // 1.向小程序发消息，更新状态
                  wx.miniProgram.postMessage({ data: { page: 'refresh' } });
                  // 2.跳转小程序银行卡认证页面
                  wx.miniProgram.redirectTo({
                    url: `/pages/bankcardAuth/authIndex?pageTitle=银行卡认证`,
                  });
                });
              });
              msg && CusToast(msg);
            })
            .catch(err => {
              CusLoadingClose();
              const msg = NotSucceedHandle(err.message);
              msg && CusToast(msg);
            });
        });
      });
    },
    // 跳转人脸识别，人脸识别不同方式不同处理
    jumpToLiveness() {
      let data = null;
      switch (this.faceDetectActivity) {
        case 0: // 不做人脸识别，直接拍照片
          data = this.createPostMessage('renLian');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 1: // 小视
          CusAlert('尚未开通甄视科技的人脸识别服务，请更换其他服务');
          break;
        case 2: // 百度
          this.setLivingFacePopupStatus(true);
          this.$refs.liveness.drawBaiduSessionCode();
          break;
        case 3: // 云码通
          data = this.createPostMessage('ymt');
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 4: // 2026.7.21 阿里
          this.initALiFaceVerify();
          break;
        case 5:  // 2026.7.21 恒信通
          this.getHXTLivenessDetectionUrl();
          break;
      }
    },
    // 2026.7 调用接口使用恒信通H5人脸活体
    getHXTLivenessDetectionUrl() {
      CusLoadingOpen();
      // ***向url中添加参数，作为当前页面onLoad后自动调用接口的标识*** //
      // ①.获取url
      const url = window.location.href;
      // ②.获取url参数对象
      const urlParams = new URLSearchParams(url.split('?')[1]);
      // ③.将设置好的url参数存入localStorage中
      localStorage.setItem("h5Face_urlParam", urlParams.toString());
      // ④.将域名和标识组成新的url当做接口入参
      const newUrl = `${url.split('?')[0]}?fromh5faceflag=h`;
      // ************************************************************************************ //
      // console.log("newUrl", newUrl);
      GetHXTLivenessDetectionUrl({
        callBackUrl: newUrl,
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            // 将返回数据集中的certifyId存入localStorage中，作为回调后查询结果的key
            localStorage.setItem("h5Face_certifyId", res.data.order_no);
            // 由于获取人脸成功后的图片是异步的，所以有没有return_url情况
            if (res.data.return_url) {
              // 有return_url直接跳转
              window.location.href = res.data.return_url;
            } else {
              // 反正，则直接调查询结果接口
              this.queryHXTLivenessDetectionResult();
            }
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => {
                if (msg.indexOf("已完成") > -1) {
                  this.queryHXTLivenessDetectionResult();
                }
              });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const message = NotSucceedHandle(err.message);
          if (message) {
            CusToast(message);
          }
        });
    },
    // 2026.7 调用接口使用阿里H5人脸活体
    initALiFaceVerify() {
      CusLoadingOpen();
      // ***向url中添加参数，作为当前页面onLoad后自动调用接口的标识*** //
      // ①.获取url
      const url = window.location.href;
      // ②.获取url参数对象
      const urlParams = new URLSearchParams(url.split('?')[1]);
      // ③.将设置好的url参数存入localStorage中
      localStorage.setItem("h5Face_urlParam", urlParams.toString());
      // ④.将域名和标识组成新的url当做接口入参
      const newUrl = `${url.split('?')[0]}?fromh5faceflag=a`;
      // ************************************************************************************ //
      InitALiFaceVerify({
        returnUrl: newUrl,
        metaInfo: JSON.stringify(window.getMetaInfo())
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            // 将返回数据集中的certifyId存入localStorage中，作为回调后查询结果的key
            localStorage.setItem("h5Face_certifyId", res.data.certifyId);
            window.location.href = res.data.certifyUrl;
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => {
                // CusAlert(`入参：${newUrl}；${JSON.stringify(window.getMetaInfo())}，结果：${JSON.stringify(res)}`);
                return;
              });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const message = NotSucceedHandle(err.message);
          if (message) {
            CusToast(message);
          }
        });
    },
    // 2026.7 调用接口查询恒信通H5人脸活体接口
    queryHXTLivenessDetectionResult(callback = null) {
      CusLoadingOpen();
      QueryHXTLivenessDetectionResult({
        order_no: localStorage.getItem("h5Face_certifyId")
      })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(res.code, res.msg, () => {
            this.renLian.webUrl = res.data.livingImgUrl;
            callback && callback();
          }, (code, msg) => {
            if (msg) {
              CusAlert(msg, () => { return });
            }
          });
        })
        .catch(err => {
          CusLoadingClose();
          const message = NotSucceedHandle(err.message);
          if (message) {
            CusToast(message);
          }
        });
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'LargeAuthen',
        imgType: imgTypeStr,
        bankName: this.formData.bankName,
        bankCardNo: this.formData.bankCardNo,
        rlWebUrl: encodeURIComponent(this.renLian.webUrl.replace('?', '|')),
        scWebUrl: encodeURIComponent(this.shouChi.webUrl.replace('?', '|')),
        h5faceCertifyId: localStorage.getItem("h5Face_certifyId") || '',
      };
    },
    // 调用云码通的接口做人脸识别
    yMTivingThing() {
      CusLoadingOpen();
      YMTivingThing({ url: this.renLian.webUrl })
        .then(res => {
          CusLoadingClose();
          if (res.code === 0) {
            this.renLian.webUrl = this.renLian.webUrl;
            this.renLian.fileUrl = this.renLian.webUrl;
            this.renLian.base64 = this.renLian.webUrl;
          } else {
            CusAlert(res.msg, () => {
              this.renLian.webUrl = '';
              this.renLian.fileUrl = '';
              this.renLian.base64 = '';
            });
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case 'shouChi':
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
        case 'renLian':
          this.jumpToLiveness();
          break;
      }
    },
    // 恒信通获取人脸照片按钮点击事件
    onHxtGetFaceBtnClick() {
      this.queryHXTLivenessDetectionResult();
    }
  },
};
</script>

<style lang="scss" scoped>
.margin-t-15 {
  margin-top: 0.75rem;
}

.form-item {
  line-height: 1;
  padding: 0.6rem 0;

  input[type='tel'] {
    width: 100%;
    font-size: $title3;
    outline: 0;
    padding: 0;
    border: 0;

    &:disabled {
      background-color: $highlight-color;
      color: $word-color;
    }

    &::-webkit-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &::-moz-placeholder {
      color: $explain-color;
      font-size: $title3;
    }

    &:-ms-input-placeholder {
      color: $explain-color;
      font-size: $title3;
    }
  }

  .code {
    width: 6rem;
    text-align: right;
    padding-right: 0.75rem;
    @include dynamic-color;

    &.disabled {
      color: $explain-color !important;
    }
  }
}

.line {
  height: 1px;
  border-bottom: 1px solid $border-color;
}

.btn-box {
  width: 100%;
  height: 6.3rem;
  line-height: 1;
  position: relative;

  .btn {
    border: 1px solid;
    @include dynamic-border-color;
    @include dynamic-color;
    padding: 0.25rem;
    border-radius: 0.3rem;
    position: absolute;
    left: 0.4rem;
    bottom: 0;
  }
}
</style>
